// blog data

export const Blogs = [
    {
        id:1,
        name:"Kamaes",
        review: "Los kamaes o posiciones, son las posiciones basicas que deben aprender los practicantes de Budo...",
        description:"Los kamaes o posiciones, son las posiciones basicas que deben aprender los practicantes de Budo(real), con esto el cuerpo se acostumbrara a aplicar los movimientos necesarios para la defensa efectiva.",
        imgSrc:"https://i.pinimg.com/564x/30/b9/ad/30b9adc38b8e45ab5ef15b15097b564d.jpg",
        type: "img",
    },
    {
        id:2,
        name:"Armas Ninja",
        review: "Estas son algunas de las armas mas utilizadas por los ninjas en la era samurai...",
        description:"Estas son algunas de las armas mas utilizadas por los ninjas en la era samurai y también podemos apreciar el como eran utilizadas.",
        imgSrc:"https://i.pinimg.com/originals/5e/50/00/5e500076a471b009d67129d845b9998e.jpg",
        type: "img",
    },
    {
        id:3,
        name:"Kihon Happo",
        review:"Según Hatsumi Sensei, el Kihon Happo es la raíz de los ocho grandes árboles que llegan hasta el cielo...",
        description:"Según Hatsumi Sensei, el Kihon Happo es la raíz de los ocho grandes árboles que llegan hasta el cielo. El Kihon Happo es un conjunto de técnicas pertenecientes a la escuela Gyokko Ryu Koshijutsu. Las ocho técnicas se dividen en dos grupos: Kosshi kihon sanpo no kata (Golpes y puntos vitales) y Torite Kihon Goho no Kata (Luxaciones y proyecciones).",
        imgSrc:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSg7sW4B6B6wtQXWuJLzOpFyyKgCS-EZSkLmA&usqp=CAU",
        type:"img",
    },
    {
        id:4,
        name:"Las 9 escuelas",
        review: "En Bujinkan se estudian 9 escuelas guerreras...",
        description:"En Bujinkan se estudian 9 escuelas guerreras, las cuales son: Togakure Ryu Ninjutsu, Kumogakure Ryu Ninjutsu, Gyokushin Ryu Ninjutsu, Gyokko Ryu Koshijutsu, Koto Ryu Koppojutsu, Gikan Ryu Koppojutsu, Takagi Yoshin Ryu Jutaijutsu, Kuki Shinden Ryu Happohikenjutsu, Shinden Fudo Ryu Dakentaijutsu",
        imgSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/ryuha.jpg",
        type:"img",
    },
    {
        id:5,
        name:"Fu no kata",
        review: "Viento",
        description:"Agradecimientos a Tiktok y a @moryudojo",
        imgSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/5elementos.jpg",
        videoSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/funokata.mp4",
        type:"video",
    },
    {
        id:6,
        name:"Ka no kata",
        review: "Fuego",
        description:"Agradecimientos a Tiktok y a @moryudojo",
        imgSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/5elementos.jpg",
        videoSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/kanokata.mp4",
        type:"video",
    },
    {
        id:7,
        name:"Sui no kata",
        review: "Agua",
        description:"Agradecimientos a Tiktok y a @moryudojo",
        imgSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/5elementos.jpg",
        videoSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/suinokata.mp4",
        type:"video",
    },
    {
        id:8,
        name:"Chi no kata",
        review: "Tierra",
        description:"Agradecimientos a Tiktok y a @moryudojo",
        imgSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/5elementos.jpg",
        videoSrc:"https://bokuryudojobucket.s3.sa-east-1.amazonaws.com/chinokata.mp4",
        type:"video",
    }
] 